import React, { useEffect, useState } from "react";
import {
    alpha,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import EventBusyRounded from "@mui/icons-material/EventBusyRounded";
import { BlockedTimeSlot } from "../Dashboard/Calendar/BlockedSlotItem";
import ToggleButton from "../ToggleButton";
import Button from "../Button";
import { FONTS } from "../../constants/styles";

interface Props {
    open: boolean;
    slot: BlockedTimeSlot;
    onClose: () => void;
    onConfirm: (mode: "single" | "all") => void;
}

const DeleteSlotModal: React.FC<Props> = ({
    open,
    slot,
    onClose,
    onConfirm,
}) => {
    const theme = useTheme();
    const hex = theme.palette.primary.main;
    const [deleteAll, setDeleteAll] = useState(false);

    useEffect(() => {
        if (open) setDeleteAll(false);
    }, [open]);

    return (
        <Dialog
            className="force-dynamic-translation"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    p: 3,
                    textAlign: "center",
                    boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.12)",
                    maxWidth: 360,
                    mx: 2,
                },
            }}
        >
            <DialogTitle sx={{ p: 0, pb: 0.5 }}>
                <Stack spacing={2} alignItems="center">
                    {/* Tinted icon box */}
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "14px",
                            bgcolor: alpha(hex, 0.1),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 auto",
                            color: hex,
                        }}
                    >
                        <EventBusyRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Typography
                        fontFamily={FONTS.display}
                        fontWeight={700}
                        fontSize="20px"
                    >
                        Unblock this slot?
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ p: 0, pt: 1 }}>
                <Stack spacing={2} alignItems="center">
                    <Typography
                        fontWeight={400}
                        fontSize="14px"
                        lineHeight="150%"
                        color="text.secondary"
                    >
                        This time will become available for bookings again
                    </Typography>

                    {slot.repeats !== "none" && (
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <ToggleButton
                                value={deleteAll}
                                onClick={setDeleteAll}
                            />
                            <Typography
                                fontSize="14px"
                                color="text.secondary"
                                fontWeight={400}
                            >
                                All occurrences in future
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            </DialogContent>
            <DialogActions
                sx={{ justifyContent: "center", p: 0, pt: 2.5 }}
            >
                <Button
                    onClick={() => {
                        onConfirm(deleteAll ? "all" : "single");
                        onClose();
                    }}
                    variant="medium"
                    color="primary"
                >
                    Unblock
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSlotModal;
